import actions from "~/shared/actions";
import type { Action } from "~/utils/actions";

export interface FlytState {
	antallSider: number | undefined;
}

const defaultState: FlytState = {
	antallSider: undefined,
};

export default function flyt(state = defaultState, action: Action): FlytState {
	switch (action.type) {
		case actions.RESET_ANTALL_SIDER:
			return { antallSider: undefined };
		case actions.SETT_ANTALL_SIDER:
			return { antallSider: action.data };
		default:
			return state;
	}
}
